/**
 * Sets document.title from site_settings (admin app).
 * @param {string} [title]
 * @param {string} [fallback]
 */
export function applySiteDocumentTitle(title, fallback = '') {
  const t = String(title ?? '').trim() || String(fallback ?? '').trim();
  if (t && typeof document !== 'undefined') {
    document.title = t;
  }
}
